export default "__VITE_ASSET__aDy6F1QV__"